module.exports = __webpack_public_path__ + "img/ticket-notification-label.8e424efc.svg";